import { render, staticRenderFns } from "./activityBasicInformation.vue?vue&type=template&id=70a10bd2&scoped=true"
import script from "./activityBasicInformation.vue?vue&type=script&lang=js"
export * from "./activityBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./activityBasicInformation.vue?vue&type=style&index=0&id=70a10bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a10bd2",
  null
  
)

export default component.exports